import {useBreakpointValue} from '@chakra-ui/react';
import colors from '../../constants/colors';
import useTypography from '../../constants/typography';

export const useTitleStyle = () => ({
    textAlign: 'left',
    color: colors.primary,
    ...useTypography(useBreakpointValue).heroTitle,
});
